import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function HotTubIcon(props: IconProps) {
    return <Icon {...props} iconKey={"hot_tub"}/>
}
